import { createSelector } from 'reselect';
import { CURRENCY } from '../../config/consts';

const EMPTY_STRING = '';

export const getCompanyData = ({ company }) => company.data;
export const getCompanyId = (state) => getCompanyData(state)?.id ?? undefined;
export const getCompanyName = (state) => getCompanyData(state)?.name || '';
export const getCurrentCompanyCurrencySelector = (state) => getCompanyData(state)?.currency || CURRENCY.EUR;
export const getMvSdkSettingsIsDefault = (state) => state.company.mvSdk.isDefault;
export const getMvSdkSettingsIsLoading = (state) => state.company.mvSdk.isFetching;
export const getMvSdkSettingsSelector = createSelector(
  ({ company }) => company.mvSdk.data,
  (data) => ({
    authKey: data?.apnConfiguration?.authKey || EMPTY_STRING,
    bundleId: data?.apnConfiguration?.bundleId || EMPTY_STRING,
    databaseName: data?.fcmConfiguration?.databaseName || EMPTY_STRING,
    keyId: data?.apnConfiguration?.keyId || EMPTY_STRING,
    serviceJson: data?.fcmConfiguration?.serviceJson || EMPTY_STRING,
    teamId: data?.apnConfiguration?.teamId || EMPTY_STRING,
  })
);
export const isCompanyFetching = ({ company }) => company.isFetching;

export const isCompanyError = (state) => !!state.company.error;

export const didInvalid = (state) => state.company.isDidInvalid;
